import '../../styles/theme.scss';
// import { globalWindow } from '../utils/constants';
// We may bring things in here which are absolutely necessary - think core styles for instance
